"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSDeviceConnector = void 0;
const deviceConnector_1 = require("../deviceConnector");
// @constants
const platform_1 = require("../../../platform");
class IOSDeviceConnector extends deviceConnector_1.DeviceConnector {
    constructor() {
        super(...arguments);
        this.webViewPlatform = platform_1.Platform.IOS;
        this.areToolsLoaded = () => { var _a; return !!((_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers); };
        this.call = (type, payload) => {
            var _a, _b, _c;
            (_c = (_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers[type]) === null || _b === void 0 ? void 0 : _b.postMessage) === null || _c === void 0 ? void 0 : _c.call(_b, JSON.stringify(payload));
        };
    }
}
exports.IOSDeviceConnector = IOSDeviceConnector;
//# sourceMappingURL=deviceConnectorIos.js.map